// extracted by mini-css-extract-plugin
export default {"link":"about-page_link__6I8ka"};